export enum EThreshold {
    DOLLARS = 'DOLLARS',
    RVUS = 'RVUS',
    EMPTY = '',
}